class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  async updateQuantity(line, quantity, name) {

    const restrictedProductHandle= "haustierportrait-individueller-schlusselanhanger";
    const restrictedFraneHandle = "poster";
    const maxAllowedQuantity = 3;
    var safe_int = parseInt(quantity)
  
    const cartResponse = await fetch("/cart.js")
    const cartData = await cartResponse.json()
  
    const lineItem = cartData.items[line - 1]
    
    //if (lineItem.handle.includes(restrictedProductHandle)) {
      //console.log("Das Line-Item ist ein individueller Haustierporträt-Schlüsselanhänger.");
    //}
  
    if (lineItem && lineItem.handle.includes(restrictedProductHandle) && safe_int > 3 && window.gift_box_abtest) {
      console.log("maxAllowedQuantity active on: haustierportrait-individueller-schlusselanhanger-personalisiert")
      // Find the quantity input field using the specific selectors from your HTML
      const quantityInput = document.querySelector(`#Drawer-quantity-${line}`) || 
                            document.querySelector(`[data-index="${line}"].quantity__input`) ||
                            document.querySelector(`input.quantity__input[data-index="${line}"]`);
      
      // Reset the quantity input to maxAllowedQuantity
      if (quantityInput) {
        quantityInput.value = maxAllowedQuantity;
        
        // Dispatch a change event to ensure Shopify's cart scripts recognize the change
        const event = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(event);
      }
      
      const lineItemError =
        document.getElementById(`CartDrawer-LineItemError-${line}`) ||
        document.getElementById(`CartItem-LineItemError-${line}`);
    
      if (lineItemError) {
        const errorTextElement = lineItemError.querySelector(".cart-item__error-text");
        if (errorTextElement) {
          errorTextElement.textContent = window.cartStrings.quantityError.replace('[quantity]', maxAllowedQuantity);
        }
    
        lineItemError.classList.remove("hidden");
        lineItemError.style.display = "flex";
      }
    
      this.disableLoading();
      
      // You might also need to update the cart state in Shopify
      // This ensures the cart reflects the correct quantity
      const formData = new FormData();
      formData.append('id', lineItem.id);
      formData.append('quantity', maxAllowedQuantity);
      
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      }).then(response => response.json())
        .then(data => {
          // Optionally refresh cart display or trigger cart update event
          if (typeof this.updateQuantity === 'function') {
            // If there's a method to update the UI, call it
            this.updateQuantity(line, maxAllowedQuantity, name);
          }
        });
      
      return false; 
    }
  

    this.enableLoading(line);

    var body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    if (lineItem.handle.includes(restrictedProductHandle)) {
      const removedUpsell = await this.checkAndRemoveUpsellProducts(line, quantity, body);
      if(removedUpsell){
        body = JSON.stringify({
          line: parseInt(line)-1,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
      }
    }

    var useUpdateEndpoint = false;
    if (lineItem.handle.includes(restrictedFraneHandle) || lineItem.handle.includes("flux")) {
      const removedUpsell = await this.checkAndRemoveFrame(line, quantity, lineItem);
      
      if(removedUpsell){
        useUpdateEndpoint = true;
        body = JSON.stringify(removedUpsell);
      }
    }

    await fetch(`${!useUpdateEndpoint ? routes.cart_change_url : `${routes.cart_update_url}.js`}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.items_removed && parsedState.items_removed.length > 0) {
          const itemRemovedEvent = new CustomEvent('cart:item-removed', {
            detail: {
              items: parsedState.items_removed,
            },
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(itemRemovedEvent);
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading();

        if( Upsell?.isCartEmpty(parsedState) ){
            Upsell?.emptyCart(parsedState);
            return
        }
        document.dispatchEvent(new CustomEvent('cart:items-rerendered'));
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const drawer = document.querySelector('cart-drawer')
    drawer.classList.add('cart__drawer--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);

    document.querySelector('cart-drawer')
        ?.classList.add('reloading');
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    document.querySelector('cart-drawer')
        ?.classList.remove('cart__drawer--disabled');

    document.querySelector('cart-drawer')
        ?.classList.remove('reloading');
  }

  async checkAndRemoveUpsellProducts(line, quantity, body) {
    // Only proceed if we're removing an item (quantity = 0)
    if (quantity != 0) return false;
    
    try {
      let updates = {
        50804126449930: 0,
      };
      
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      
      // Return false to indicate we should continue with the normal flow
      return true;
    } catch (error) {
      console.error('Error checking for dependent products:', error);
      return false;
    }
  }

  async checkAndRemoveFrame(line, quantity, lineItem) {
    // Only proceed if we're removing an item (quantity = 0)
    //if (quantity != 0) return false

    try {
      const cartResponse = await fetch("/cart.js")
      const cartData = await cartResponse.json()
      const currentItem = cartData.items[Number.parseInt(line) - 1]


      const frameLineToRemove = cartData.items.find((item, index) => {
        if (item.properties) {
          const frameProperty = Object.keys(item.properties).find((key) =>
            key.includes("_frame_belong_to_key")
          );
        
          if (frameProperty) {
            const posterKeyProperty = Object.keys(currentItem.properties || {}).find((key) =>
              key.includes("_poster_key")
            );
          
            if (posterKeyProperty) {
              const posterKeyValue = currentItem.properties[posterKeyProperty];       
              return item.properties[frameProperty] === posterKeyValue;
            }
          }
        }
        return false
      })

      if(frameLineToRemove && frameLineToRemove.key){
          return {
            updates: {
              [frameLineToRemove.key]:quantity,
              [lineItem.key]:quantity  
            },
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          }
      }


     
      if (frameLineToRemove === -1) return false

      return false
    } catch (error) {
      console.error("Error checking for dependent products:", error)
      return false
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

